import React, { useContext } from 'react';
import { isMobile } from "react-device-detect";

import LocaleContext from 'contexts/locale-context';

import navigateToLink from 'helpers/navigate-to-link';

import Select from 'components/select';
import Spacer from 'components/spacer';

import './index.css';

const Footer = ({ suffix = '' }) => {
  const { locale, translations } = useContext(LocaleContext);
  const commonTranslations = translations.common;

  let _suffix = '';

  if (suffix) {
    _suffix = `/${suffix}`;
  }

  let selected;

  switch(locale) {
    case 'hi':
      selected = `/hi${_suffix}`;
      break;
    case 'pt':
      selected = `/pt${_suffix}`;
      break;
    default:
      selected = `/en${_suffix}`;
  }

  return (
    <footer className={`footer ${isMobile ? 'footer--mobile' : ''}`}>
      <div className={`contact ${isMobile ? 'contact--mobile' : ''}`}>
        <a href='mailto:hello@midrive.io?Subject=Contact%20Us'>
          {commonTranslations.contact_us}
        </a>
        <a href='mailto:hello@midrive.io?Subject=Report%20an%20issue'>
          {commonTranslations.report_issue}
        </a>
        <a href={`/${locale}/terms-of-use`}>
          {commonTranslations.footer_terms_of_use}
        </a>
        <a href={`/${locale}/privacy-policy`}>
          {commonTranslations.footer_privacy_policy}
        </a>
      </div>

      <Spacer size='xs'/>

      <div className={`language ${isMobile ? 'language--mobile' : ''}`}>
        <p>{commonTranslations.language}</p>
        <Select
          value={selected}
          onChange={e => {
            navigateToLink(e.target.options[e.target.selectedIndex].value)
          }}
        >
          <option value={`/en${_suffix}`}>
            English
          </option>
          <option value={`/hi${_suffix}`}>
            Hindi
          </option>
          <option value={`/pt${_suffix}`}>
            Portuguese
          </option>
        </Select>
      </div>
    </footer>
    )
  }
  
  export default Footer;